import { Tooltip } from '@chakra-ui/react';
import React, { useState, useRef } from 'react';

interface Props {
  children: string | number;
  tooltipLabel?: React.ReactNode;
  size?: 'small' | 'medium';
}

const BadgeWithMessage = ({ children, tooltipLabel, size = 'medium' }: Props) => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleTouch = () => {
    if (window.innerWidth >= 768) return;

    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setIsMobileOpen(true);

    timeoutRef.current = setTimeout(() => {
      setIsMobileOpen(false);
    }, 3000);
  };

  const sizeClasses =
    size === 'small'
      ? 'text-xs pt-spacing-xs pr-spacing-md pb-spacing-xs pl-spacing-md'
      : 'text-sm pt-spacing-xs pr-spacing-xl pb-spacing-xs pl-spacing-xl';

  return (
    <Tooltip
      label={tooltipLabel}
      placement="top"
      background="#FFF7E6"
      color="#101828"
      hasArrow
      isOpen={window.innerWidth < 768 ? isMobileOpen : undefined}
      closeOnClick={false}
      closeOnEsc={false}
      shouldWrapChildren>
      <div
        onTouchStart={handleTouch}
        className={`border border-warning-200 bg-warning-50 r text-warning-700 rounded-full ${sizeClasses}`}>
        {children}
      </div>
    </Tooltip>
  );
};

export default BadgeWithMessage;
